import Invoicing from './invoicing';
import SiloInvoices from './silo-invoices';
import Receiving from './receiving';
import ProcessedFluidReceiving from './processed-fluid-receiving';
import Bays from './user-management/plant-management/bays';
import Tanks from './user-management/producer-management/tanks';
import LoanManagement from './loan-management';
import PaymentLineItemConfigs from './payment-line-item-configs';
import ContractManagement from './contract-management';
import PriceManagement from './price-management';
import PaymentStatus from './payment-status';
import ProcessedFluidInvoicing from './processed-fluid-invoicing';
import AssigneeApp from './assignees';
import ProcessedFluidRapidTest from './processed-fluid-rapid-test';

export default [
    ...Invoicing,
    ...SiloInvoices,
    Receiving,
    ProcessedFluidReceiving,
    ProcessedFluidRapidTest,
    ...Bays,
    ...Tanks,
    ...PaymentLineItemConfigs,
    ...LoanManagement,
    ContractManagement,
    ...PriceManagement,
    ...PaymentStatus,
    ...ProcessedFluidInvoicing,
    ...AssigneeApp,
    // wrap
];
